import { render, staticRenderFns } from "./GlobalSettingsView.vue?vue&type=template&id=349dc71e&"
import script from "./GlobalSettingsView.vue?vue&type=script&lang=js&"
export * from "./GlobalSettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports